




















import {Component, Vue, Prop} from 'vue-property-decorator';
import {LogEntry, LogPage, OperationsService} from "@/services/operations-service";

@Component({
})
export default class OperationsDebugJSON extends Vue {
    private entity: string | null = null;
    private id: number | null = null;

    private operationsService!: OperationsService;
    private data : string | null = null;

    created() {
        this.operationsService = new OperationsService();
    }

    async load_json() {
        if (!this.id || !this.entity) return;
        const json = await this.operationsService.DebugJSON(this.entity, this.id);
        this.data = JSON.stringify(JSON.parse(json), null, 2);
    }
}
